import { render, staticRenderFns } from "./OrderDetailShipment.vue?vue&type=template&id=011ade50&scoped=true&"
import script from "./OrderDetailShipment.vue?vue&type=script&lang=js&"
export * from "./OrderDetailShipment.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailShipment.vue?vue&type=style&index=0&id=011ade50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011ade50",
  null
  
)

export default component.exports